<template>
  <div class="help-page">
    <img :src="require('@/assets/help/helpbanner.png')" alt="Carousel Image" style="display: inline-block;width: 100%;">
    <!-- 面包屑 -->
    <!-- <div class="x-help-bread">首页 <i class="el-icon-arrow-right x-help-icon"></i> 帮助中心</div> -->
    <!-- 热门问题 -->
    <div class="help">
      <div class="help-title">热门问题</div>
      <div class="help-box">
        <div class="help-item">
          <div class="help-img-box">
            <img class="help-img" :src="require('@/assets/help/hlpe.png')" alt="">
          </div>
          <div class="help-content">
            <div class="help-name">订单查不到如何处理</div>
            <div class="help-cont">在网站或者微信公众号中可查看订单号，或者联系客服进行处理</div>
          </div>
        </div>
        <div class="help-item">
          <div class="help-img-box">
            <img class="help-img" :src="require('@/assets/help/hlpe.png')" alt="">
          </div>
          <div class="help-content">
            <div class="help-name">如何查询运单</div>
            <div class="help-cont">进入网站首页，点击“货物追踪”，填写运单号进行查询</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>
<style lang="scss" scoped>
.help-page{
  width: 100%;
  height: 100%;
  background: #fff;

  .x-help-bread{
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    background: #00AECF ;
    box-sizing: border-box;
    padding-left: 10%;
    color: #fff;
    font-size: 14px;
    .x-help-icon{
      padding: 0 5px;
      margin-top: 3px;
    }
  }
  .help{
    width: 80%;
    margin: 0 auto;
    min-width: 1200px;
    .help-title{
      width: 100%;
      font-size: 36px;
      height: 120px;
      line-height: 120px;
      text-align: center;
      font-weight: bold;  
    }
    .help-box{
      width: 900px;
      height: 300px;
      margin-bottom: 60px;
      display: flex;
      flex-direction: column;
      margin: 0 auto;
      .help-item{
        width: 100%;
        height: 130px;
        box-sizing: border-box;
        background: #FFFFFF;
        box-shadow: 4px 0px 10px 0px #CDCDCD;
        border-radius: 6px 6px 6px 6px;
        margin-bottom: 10px;
        box-sizing: border-box;
        padding: 31px 40px;
        display: flex;
        .help-img-box{
          width: 35px;
          margin-right: 30px;
          .help-img{
            width: 35px;
            height: 35px;
          }
        }
        .help-content{
          flex: 1;
          .help-name{
            font-size: 18px;
            line-height: 32px;
            text-align: left;
            margin-bottom: 10px;
            font-family: HarmonyOS_Sans_SC_Medium;
          }
          .help-cont{
            width: 100%;
            font-size: 14px;
            line-height: 20px;
            text-align: left;
            color: #666666;
          }
        }

      }
      .help-item:last-child{
        border: none;
      }
    }
  }
}
</style>